import React from 'react';
import {t} from '@lingui/core/macro';

import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

import styles from './HttpMonitorStatistics.module.scss';

interface IHttpMonitorStatisticsProps {
    item: IHttpMonitorItem;
    tzString?: string | null;
}

const HttpMonitorStatistics: React.FC<IHttpMonitorStatisticsProps> = ({item, tzString}) => {
    const dateFormat = !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm';
    const formatDate = (date: string | null) => getFormattedDate(date, {format: dateFormat, tzString});

    return (
        <div className={styles.statistics}>
            <span>{t`Метод запроса`}: {item.method}</span>
            <span>{t`Интервал проверки`}: {item.check_interval} {t`мин.`}</span>
            <span>{t`Таймаут запроса`}: {item.http_request_timeout} {t`сек`}.</span>
            <span>{t`Доступность за 24 часа`}: {item.availability1}%</span>
            <span>{t`Доступность за 7 дней`}: {item.availability7}%</span>
            <span>{t`Доступность за 30 дней`}: {item.availability30}%</span>
            <span>{t`Монитор создан`}: {formatDate(item.created_at)}</span>
            <span>{t`Последняя проверка`}: {formatDate(item.last_check)}</span>
            <span>{t`Следующая проверка`}: {formatDate(item.next_check)}</span>
        </div>
    );
};

export default HttpMonitorStatistics;